// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"3925":"40c0e79a3685e7cd383b","3959":"59946c7ad71f0950799b"}[chunkId] + ".css";
};